import { S3_IMAGES_URL } from '../../../constants';

export const ACHIEVEMENTS = [
  {
    id: 1,
    title: 'First five installs with your link',
    description:
      'Invite five friends to complete registrations in the app using your referral link',
    icons: [
      {
        id: 1,
        src: `${S3_IMAGES_URL}earn_block/card_1_icon_1.svg`,
      },
      {
        id: 2,
        src: `${S3_IMAGES_URL}earn_block/card_1_icon_2.svg`,
      },
    ],
  },
  {
    id: 2,
    title: 'First app booking from your friend',
    description: `Your friend's first booking using the app`,
    icons: [
      {
        id: 1,
        src: `${S3_IMAGES_URL}earn_block/card_2_icon_2.svg`,
      },
      {
        id: 2,
        src: `${S3_IMAGES_URL}earn_block/card_2_icon_1.svg`,
      },
    ],
  },
  {
    id: 3,
    title: 'First crypto payment from your friend',
    description: `Your friend's first booking with crypto`,
    icons: [
      {
        id: 1,
        src: `${S3_IMAGES_URL}earn_block/card_3_icon_1.svg`,
      },
      {
        id: 2,
        src: `${S3_IMAGES_URL}earn_block/card_3_icon_2.svg`,
      },
      {
        id: 3,
        src: `${S3_IMAGES_URL}earn_block/card_3_icon_3.svg`,
      },
      {
        id: 4,
        src: `${S3_IMAGES_URL}earn_block/card_3_icon_4.svg`,
      },
      {
        id: 5,
        src: `${S3_IMAGES_URL}earn_block/card_3_icon_5.svg`,
      },
    ],
  },
];
